import React from 'react'
import clsx from 'clsx'

import HeaderLogo from './header_logo/View'
import HeaderDomains from './header_domains/View'
import MenuItem from './MenuItem'
import ChallengePopup from '../challengePopup/ChallengePopup'

const NavbarLeft = ({
  classes,
  openMenu,
  toggleMenu,
  closeMenu,
  logoUrl,
  onLogoClick,
  domains,
  navigateToDomain,
  navbarItems,
  handleDomainChange,
  whiteListDomainLoading,
  showChallengeModal,
  openChallengeModal,
  closeChallengeModal,
  isHackathonEnable,
}) => {
  return (
    <>
      <div className={classes.menuSystem}>
        <button
          type="button"
          onClick={toggleMenu}
          className={classes.menuHumbergar}
          aria-label="Toggle menu"
        >
          <span
            className={clsx(
              classes.colorIcon,
              classes.burger,
              openMenu ? 'icon-close' : 'icon-menu'
            )}
          />
        </button>

        <HeaderLogo logoUrl={logoUrl} onLogoClick={onLogoClick} />

        <HeaderDomains navigateToDomain={navigateToDomain} domains={domains} />
      </div>

      {openMenu && (
        <button
          type="button"
          className={classes.mobileOverlay}
          onClick={closeMenu}
          aria-label="Close menu overlay"
        />
      )}

      <div
        className={clsx(classes.leftNestedNavContainer, {
          [classes.mobileDrawerOpen]: openMenu,
          [classes.mobileDrawerClose]: !openMenu,
        })}
      >
        <div className={classes.mobileDrawerHeader}>
          <span className={classes.drawerTitle}>Menu</span>

          <button
            type="button"
            onClick={closeMenu}
            className={classes.drawerCloseBtn}
            aria-label="Close menu"
          >
            ✕
          </button>
        </div>

        <MenuItem
          domains={domains}
          navbarItem={navbarItems}
          onHandleInstanceValue={handleDomainChange}
          whiteListDomainLoading={whiteListDomainLoading}
          closeSidebarMenu={closeMenu}
          onOpenModal={openChallengeModal}
          isHackathon={isHackathonEnable}
        />

        
      </div>
    </>
  )
}

export default NavbarLeft